import { render, staticRenderFns } from "./MailBox.vue?vue&type=template&id=218a9ab6&scoped=true"
import script from "./MailBox.vue?vue&type=script&lang=js"
export * from "./MailBox.vue?vue&type=script&lang=js"
import style0 from "./MailBox.vue?vue&type=style&index=0&id=218a9ab6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218a9ab6",
  null
  
)

export default component.exports